module.exports = __webpack_public_path__ + "static/media/activity.a50bea30.svg";